import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Environment, ENVIRONMENT } from '@web/config';
import { RouteFragment } from '@web/common';

@Component({
  selector: 'app-regulations-checkbox-label',
  imports: [],
  templateUrl: './regulations-checkbox-label.component.html',
  styleUrl: './regulations-checkbox-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegulationsCheckboxLabelComponent {
  private readonly environment = inject<Environment>(ENVIRONMENT);

  protected readonly link = this.prepareLink();

  private prepareLink(): string {
    return `${this.environment.AppUrl.Shop}/${RouteFragment.PL_Regulations}/${RouteFragment.PL_Shop}`;
  }
}
